module.exports = __webpack_public_path__ + "assets/Upload-Cloud2.710604c5.svg";